import MiqdorInput from "../../Component/Tables/ModalTable/KirimChiqimInputs/MiqdorInput";
import { RiStackFill } from "react-icons/ri";
import {
  DATE,
  MODALTABLE,
  STRING,
} from "../../Component/Modals/ModalComponents/ModalInputTypes";
import { SIMPLE } from "../../Component/Sidebar/PageTypes";
import MiqdorSelect from "../../Component/Tables/ModalTable/KirimChiqimInputs/MiqdorSelect";
import DocumentClass from "../../Functions/DocumentClass";
import NumberFormat from "../../Functions/NumberFormat";
import IzohInput from "../../Component/Tables/ModalTable/KirimChiqimInputs/IzohInput";
import SanaFormat from "../../Functions/SanaFormat";
import DocumentQarzi from "../../Component/Tables/ModalTable/KirimChiqimInputs/DocumentQarzi";
import SanaReturn from "../../Component/Tables/ModalTable/KirimChiqimInputs/SanaReturn";
const MijozTolov = {
  title: "Мижоз тўлов",
  path: "/mijoz-tolov",
  type: SIMPLE,
  icon: <RiStackFill></RiStackFill>,
  allData: [
    { value: "mijoz_id", prop: "mijozlar", get: "fio" },
    { value: "agent_id", prop: "agentlar", get: "fio" },
    { value: "tolov_turi", prop: "tolov_turlari", get: "nomi" },
  ],
  modalJami: "agent-tolov",
  innerData: "mijozlar",
  hisobotActions: [],
  columns: [
    {
      title: <div className="table_head">№</div>,
      key: "index",
      render: (text, record, index) => index + 1,
      width: "50px",
      align: "center",
    },
    {
      title: <div className="table_head">ID</div>,
      dataIndex: "Id",
      width: "100px",
      align: "center",
    },
    {
      title: <div className="table_head">Сана</div>,
      dataIndex: "time_create",
      key: "nomi",
      width: "150px",
      render: (text) => SanaFormat(text),
    },
    {
      title: <div className="table_head">Жами сумма</div>,
      dataIndex: "document",
      key: "nomi",
      width: "150px",
      align: "right",
      render: (text) =>
        NumberFormat(DocumentClass(text, "agent-tolov").summa_som),
    },
    {
      title: <div className="table_head">Жами сумма переч</div>,
      dataIndex: "document",
      key: "nomi",
      width: "150px",
      align: "right",
      render: (text) =>
        NumberFormat(DocumentClass(text, "agent-tolov").summa_perech),
    },
    {
      title: <div className="table_head">Жами сумма вал</div>,
      dataIndex: "document",
      key: "nomi",
      width: "150px",
      align: "right",
      render: (text) =>
        NumberFormat(DocumentClass(text, "agent-tolov").summa_val, 1) + " $",
    },
    {
      title: <div className="table_head">Изох</div>,
      dataIndex: "izoh",
      key: "nomi",
      width: "178px",
    },
  ],
  forms: [
    {
      type: "document",
      grid: "1fr",
      actionInputs: [
        {
          grid: "2fr 4fr",
          inputs: [
            {
              label: "Сана",
              name: "time_create",
              type: DATE,
            },
            {
              label: "Изох",
              name: "izoh",
              type: STRING,
            },
          ],
        },
      ],
      inputs: [
        {
          name: "document",
          type: MODALTABLE,
          innerModal: {
            title: "Мижозлар",
            columns: [
              {
                title: <div className="table_head">№</div>,
                key: "index",
                render: (text, record, index) => index + 1,
                width: "50px",
                align: "center",
              },
              {
                title: <div className="table_head">Номи</div>,
                dataIndex: "fio",
                key: "nomi",
              },
            ],
          },
          costumColumns: [
            {
              title: <div className="table_head">№</div>,
              key: "index",
              render: (text, record, index) => index + 1,
              width: "40px",
              align: "center",
            },
            {
              title: <div className="table_head">Мижоз</div>,
              dataIndex: "element_id",
              key: "nomi",
              width: 250,
              render: (text) => (
                <MiqdorSelect
                  name={"element_id"}
                  value={text}
                  cursor="1"
                  placeholder="Мижоз"
                  get="fio"
                  allDataType={"mijozlar"}
                ></MiqdorSelect>
              ),
            },
            {
              title: <div className="table_head">Агент</div>,
              dataIndex: "agent_id",
              key: "nomi",
              width: "180px",
              render: (text) => (
                <MiqdorSelect
                  name={"agent_id"}
                  value={text}
                  placeholder="Агент"
                  get="fio"
                  allDataType={"agentlar"}
                ></MiqdorSelect>
              ),
            },
            {
              title: <div className="table_head">Қарзи сўм</div>,
              dataIndex: "qarzi_som",
              key: "nomi",
              width: "100px",
              render: (text, record) => (
                <DocumentQarzi
                  turi="1"
                  sana={record.time_create}
                  mijoz_id={record.element_id}
                  agent_id={record.agent_id}
                  qarzi={NumberFormat(record.qarzi_som)}
                ></DocumentQarzi>
              ),
            },
            {
              title: <div className="table_head">Қарзи вал</div>,
              dataIndex: "qarzi_val",
              width: "100px",
              render: (text) => text + " $",
            },
            {
              title: <div className="table_head">Тўлов тури</div>,
              dataIndex: "tolov_turi",
              key: "nomi",
              width: "130px",
              render: (text) => (
                <MiqdorSelect
                  name={"tolov_turi"}
                  value={text}
                  get="nomi"
                  placeholder="Тўлов тури"
                  allDataType={"tolov_turlari"}
                ></MiqdorSelect>
              ),
            },
            {
              title: <div className="table_head">Сумма</div>,
              dataIndex: "summa_som",
              key: "nomi",
              render: (text) => (
                <MiqdorInput name="summa_som" value={text}></MiqdorInput>
              ),
              width: "130px",
            },
            {
              title: <div className="table_head">Изох</div>,
              dataIndex: "izoh",
              render: (text) => (
                <IzohInput name="izoh" value={text}></IzohInput>
              ),
            },
            {
              title: <div className="table_head">Сана</div>,
              dataIndex: "time_create",
              width: "95px",
              render: (text, record) => (
                <SanaReturn time={text} id={record.Id}></SanaReturn>
              ),
            },
          ],
        },
      ],
    },
  ],
};

export default MijozTolov;
